import React, { useState } from 'react';
import {
  Dialog,
  Box,
  Typography,
  IconButton,
  Button,
  Chip,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import WifiIcon from '@mui/icons-material/Wifi';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import HomeIcon from '@mui/icons-material/Home';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt';
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import FastForwardIcon from '@mui/icons-material/FastForward';
import TextDecreaseIcon from '@mui/icons-material/TextDecrease';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';
import MusicNoteIcon from '@mui/icons-material/MusicNote';

// Sample Telugu & English Songs matching actual mobile app screenshot
const SAMPLE_SONGS = [
  {
    id: 6,
    number: 6,
    language: 'Telugu',
    title: 'ఆత్మానొసగుమయా పావనాత్మ నొసగుమయా',
    lyrics: `ఆత్మానొసగుమయా పావనాత్మ నొసగుమయా
పరమ తండ్రీ పరలోక దేవా
వరముల నొసగు పరిశుద్ధాత్మా

1. దీనుడనై వేడుచున్నాను
నా హృదయమును నీ ఆలయముగా
మార్చుమయా ఓ పరిశుద్ధాత్మా ||ఆత్మా||

2. బలహీనుడనై యున్న వేళ
బలపరచుము నీ వాక్యముచేత
నిత్యము నన్ను నడుపుమయా ||ఆత్మా||`,
  },
  {
    id: 7,
    number: 7,
    language: 'Telugu',
    title: 'ఆత్మా నడుపు స త్యము లోని',
    lyrics: `ఆత్మా నడుపు స త్యము లోని కిపుడే
యాత్మా నడుపు ఆత్మా నీ
సాయంబు నధికంబుగా నిచ్చి
ఆత్మానందముతో దై వారాధనమున ||కాత్మా||

1. ఘోర కలుషంబుల దూరంబుగాఁ దోలి
పారమార్ధిక బుద్ధిఁ గోరు
నట్టులను ||ఆత్మా||

2. అంధత్వంబు వలన మందమైయుండు
మా డెందంబు లెల్ల నీ యందు
వెలుగుటకు ||ఆత్మా||

3. నిత్య జీవపు మార్గమందు నడువ
సత్య వాక్యపు కాంతిని మా కొసగి
పరమ తండ్రిని స్తుతియించుటకు ||ఆత్మా||`,
  },
  {
    id: 8,
    number: 8,
    language: 'Telugu',
    title: 'ఆదరింపుము యేసువా',
    lyrics: `ఆదరింపుము యేసువా నాదు ప్రాణనాథా
వేదనా భరితుడనై వేడుచుంటి నిన్నే

1. శోధనలు నను చుట్టినప్పుడు
ఆదరణ నీవే నా యేసయ్యా
పాదములు తడబడకుండ నడుపు ||ఆదరింపుము||

2. కన్నీటి లోయల గుండా నడచినను
నీ కృప నాకై చాలును ప్రభువా
నిరంతరం నిన్ను స్తుతియింతును ||ఆదరింపుము||`,
  },
  {
    id: 9,
    number: 9,
    language: 'Telugu',
    title: 'ఆనంద యాత్ర',
    lyrics: `ఆనంద యాత్ర పరలోక యాత్ర
యేసునితో మన జీవన యాత్ర

1. లోకపు శ్రమలను లెక్కించక
ముందుకు సాగెదము యేసుని వెనుక
విజయ గీతములను పాడుచు ||ఆనంద||

2. మహిమలో ప్రభువు మనకై సిద్ధపరచిన
నిత్య గృహమును చేరగోరి
హల్లేలూయా స్తుతులు పాడుచు ||ఆనంద||`,
  },
  {
    id: 10,
    number: 10,
    language: 'Telugu',
    title: 'ఆనందం -ఆనందం',
    lyrics: `ఆనందం - ఆనందం యేసునిలో ఆనందం
పాప క్షమాపణ దొరికెను నేడు
పరమ శాంతి మన హృదయములో

1. సిలువ రక్తముచే కడుగబడి
నూతన సృష్టిగా మార్చబడిన
పరిశుద్ధ జీవితం జీవించెదము ||ఆనందం||`,
  },
  {
    id: 11,
    number: 11,
    language: 'Telugu',
    title: 'ఆనంద మగు ముక్తి యే',
    lyrics: `ఆనంద మగు ముక్తి యేసు ప్రభు నొసగెన్
కృపతో నన్ను రక్షించి నిలిపెన్

1. మరణపు భయములు తొలగిపోయెను
పరలోక నిరీక్షణ నింపెను ప్రభువు
హృదయపూర్వకముగా స్తుతియింతున్ ||ఆనంద||`,
  },
  {
    id: 1,
    number: 1,
    language: 'English',
    title: 'Amazing Grace How Sweet The Sound',
    lyrics: `Amazing grace! How sweet the sound
That saved a wretch like me!
I once was lost, but now am found;
Was blind, but now I see.

'Twas grace that taught my heart to fear,
And grace my fears relieved;
How precious did that grace appear
The hour I first believed!

Through many dangers, toils and snares,
I have already come;
'Tis grace hath brought me safe thus far,
And grace will lead me home.`,
  },
  {
    id: 2,
    number: 2,
    language: 'English',
    title: 'How Great Thou Art',
    lyrics: `O Lord, my God, when I in awesome wonder
Consider all the worlds Thy Hands have made;
I see the stars, I hear the rolling thunder,
Thy power throughout the universe displayed.

Then sings my soul, My Saviour God, to Thee,
How great Thou art, how great Thou art.
Then sings my soul, My Saviour God, to Thee,
How great Thou art, how great Thou art!`,
  },
];

export default function MobileSongPreviewModal({
  open = false,
  onClose,
  isExample = true,
  liveSong = null,
  churchName = 'Way Truth Life Church',
}) {
  // Screen mode: 'list' (Songs Listing) | 'details' (Song View)
  const [screenMode, setScreenMode] = useState('list');
  const [selectedSongId, setSelectedSongId] = useState(7);
  const [selectedLanguage, setSelectedLanguage] = useState('All'); // 'All' | 'English' | 'Telugu'
  const [sortBottomSheetOpen, setSortBottomSheetOpen] = useState(false);
  const [sortBy, setSortBy] = useState('song_number'); // 'song_number' | 'alphabetical' | 'newest' | 'oldest'
  const [isPlaying, setIsPlaying] = useState(false);
  const [fontSizeOffset, setFontSizeOffset] = useState(0);

  // Active song
  const activeSong = liveSong && (liveSong.title || liveSong.song_name) ? {
    id: 999,
    number: liveSong.song_number || liveSong.song_no || 1,
    language: liveSong.language_name || 'Telugu',
    title: liveSong.title || liveSong.song_name || 'ఆత్మా నడుపు స త్యము లోని',
    lyrics: liveSong.song || liveSong.lyrics || SAMPLE_SONGS[1].lyrics,
  } : (SAMPLE_SONGS.find(s => s.id === selectedSongId) || SAMPLE_SONGS[1]);

  // Filter songs based on language tab
  const filteredSongs = SAMPLE_SONGS.filter(s => {
    if (selectedLanguage === 'All') return true;
    return s.language.toLowerCase() === selectedLanguage.toLowerCase();
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          background: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      {/* Outer Phone Mockup Frame */}
      <Box
        sx={{
          width: { xs: 340, sm: 390 },
          height: 740,
          bgcolor: '#000000',
          borderRadius: '48px',
          border: '10px solid #1E293B',
          boxShadow: '0 25px 60px rgba(0,0,0,0.8), 0 0 0 1px rgba(255,255,255,0.1)',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        {/* Floating Close Button Top Right */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 14,
            right: 14,
            zIndex: 100,
            color: '#FFFFFF',
            bgcolor: 'rgba(0,0,0,0.6)',
            backdropFilter: 'blur(8px)',
            width: 30,
            height: 30,
            '&:hover': { bgcolor: 'rgba(0,0,0,0.9)' },
          }}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>

        {/* Dynamic Island / Notch */}
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 100,
            height: 22,
            bgcolor: '#000000',
            borderRadius: '16px',
            zIndex: 90,
          }}
        />

        {/* Status Bar */}
        <Box
          sx={{
            pt: 1.5,
            px: 2.5,
            pb: 0.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: '#FFFFFF',
            bgcolor: '#000000',
            zIndex: 80,
          }}
        >
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.5px' }}>
            15:56
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
            <SignalCellularAltIcon sx={{ fontSize: 13 }} />
            <WifiIcon sx={{ fontSize: 13 }} />
            <BatteryFullIcon sx={{ fontSize: 14 }} />
          </Box>
        </Box>

        {/* Top App Header with Church Name & Back Button */}
        <Box
          sx={{
            bgcolor: '#000000',
            px: 2,
            py: 1.2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            zIndex: 70,
          }}
        >
          <Typography
            sx={{
              color: '#FFFFFF',
              fontSize: '0.98rem',
              fontWeight: 700,
              flex: 1,
              textAlign: 'center',
              pl: 4,
            }}
          >
            {churchName}
          </Typography>

          <Button
            size="small"
            startIcon={<ArrowBackIosNewIcon sx={{ fontSize: '13px !important' }} />}
            onClick={() => {
              if (screenMode === 'details') {
                setScreenMode('list');
              } else {
                onClose?.();
              }
            }}
            sx={{
              color: '#FFFFFF',
              textTransform: 'none',
              fontSize: '0.82rem',
              fontWeight: 600,
              minWidth: 'auto',
              p: 0.5,
            }}
          >
            Back
          </Button>
        </Box>

        {/* Mode Pill Toggle (User Example Indicator) */}
        <Box
          sx={{
            bgcolor: '#111827',
            py: 0.5,
            px: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid rgba(76, 161, 175, 0.2)',
          }}
        >
          <Chip
            size="small"
            label="📱 Mobile User Example"
            sx={{
              bgcolor: 'rgba(13, 148, 136, 0.25)',
              color: '#2DD4BF',
              fontSize: '0.68rem',
              fontWeight: 700,
              height: 20,
              border: '1px solid rgba(45, 212, 191, 0.4)',
            }}
          />
          <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.68rem' }}>
            {screenMode === 'list' ? 'Tap any song to view lyrics' : 'Viewing Song Details'}
          </Typography>
        </Box>

        {/* ======================================================== */}
        {/* SCREEN 1: SONGS LIST VIEW (Matches User Screenshot 1)    */}
        {/* ======================================================== */}
        {screenMode === 'list' && (
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              bgcolor: '#FFFFFF',
              color: '#0F172A',
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
            }}
          >
            {/* Search Bar & Filter Button Row */}
            <Box sx={{ p: 2, pb: 1, display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <IconButton size="small" sx={{ color: '#0D9488' }}>
                <SearchIcon sx={{ fontSize: 24 }} />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => setSortBottomSheetOpen(true)}
                sx={{ color: '#0D9488' }}
              >
                <FilterListIcon sx={{ fontSize: 24 }} />
              </IconButton>

              {/* Language Tabs: All, English, Telugu */}
              <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
                {['All', 'English', 'Telugu'].map((lang) => (
                  <Chip
                    key={lang}
                    label={lang}
                    onClick={() => setSelectedLanguage(lang)}
                    sx={{
                      bgcolor: selectedLanguage === lang ? '#1F6F78' : '#E2E8F0',
                      color: selectedLanguage === lang ? '#FFFFFF' : '#334155',
                      fontWeight: 700,
                      fontSize: '0.78rem',
                      height: 30,
                      px: 0.5,
                      borderRadius: '16px',
                      cursor: 'pointer',
                      '&:hover': {
                        bgcolor: selectedLanguage === lang ? '#155E63' : '#CBD5E1',
                      },
                    }}
                  />
                ))}
              </Box>
            </Box>

            {/* Song Cards List */}
            <Box sx={{ px: 2, pb: 10, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {filteredSongs.map((song) => (
                <Box
                  key={song.id}
                  onClick={() => {
                    setSelectedSongId(song.id);
                    setScreenMode('details');
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.75,
                    p: 1.25,
                    bgcolor: '#F8FAFC',
                    borderRadius: '12px',
                    border: '1px solid #E2E8F0',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 12px rgba(13, 148, 136, 0.12)',
                      borderColor: '#14B8A6',
                    },
                  }}
                >
                  {/* Dark Neon Thumbnail Icon */}
                  <Box
                    sx={{
                      width: 58,
                      height: 58,
                      borderRadius: '10px',
                      bgcolor: '#0F172A',
                      backgroundImage: 'radial-gradient(circle at center, #1E293B 0%, #0F172A 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      border: '1px solid rgba(20, 184, 166, 0.3)',
                      boxShadow: 'inset 0 0 10px rgba(20, 184, 166, 0.2)',
                    }}
                  >
                    <MusicNoteIcon
                      sx={{
                        fontSize: 28,
                        color: '#38BDF8',
                        filter: 'drop-shadow(0 0 6px #0284C7)',
                      }}
                    />
                  </Box>

                  {/* Song Details */}
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: '0.94rem',
                        fontWeight: 700,
                        color: '#164E63',
                        lineHeight: 1.35,
                        mb: 0.3,
                      }}
                      noWrap
                    >
                      {song.title}
                    </Typography>
                    <Typography sx={{ fontSize: '0.78rem', color: '#64748B', fontWeight: 600 }}>
                      Song # {song.number}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>

            {/* Bottom Sheet "Sort By" Modal Overlay (Matches User Screenshot 2) */}
            {sortBottomSheetOpen && (
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  bgcolor: 'rgba(0,0,0,0.6)',
                  backdropFilter: 'blur(3px)',
                  zIndex: 85,
                  display: 'flex',
                  alignItems: 'flex-end',
                }}
                onClick={() => setSortBottomSheetOpen(false)}
              >
                <Box
                  sx={{
                    width: '100%',
                    bgcolor: '#FFFFFF',
                    borderTopLeftRadius: '24px',
                    borderTopRightRadius: '24px',
                    p: 2.5,
                    boxShadow: '0 -8px 24px rgba(0,0,0,0.2)',
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Typography variant="h6" fontWeight={800} sx={{ mb: 1.5, color: '#0F172A' }}>
                    Sort By
                  </Typography>

                  <RadioGroup
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    {[
                      { value: 'song_number', label: 'Song Number' },
                      { value: 'alphabetical', label: 'Alphabetical' },
                      { value: 'newest', label: 'Newest' },
                      { value: 'oldest', label: 'Oldest' },
                    ].map((opt) => (
                      <Box
                        key={opt.value}
                        sx={{
                          py: 1,
                          borderBottom: '1px solid #F1F5F9',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Typography sx={{ fontSize: '0.92rem', fontWeight: 600, color: '#1E293B' }}>
                          {opt.label}
                        </Typography>
                        <Radio
                          checked={sortBy === opt.value}
                          value={opt.value}
                          sx={{
                            color: '#CBD5E1',
                            '&.Mui-checked': { color: '#0F766E' },
                            p: 0.5,
                          }}
                        />
                      </Box>
                    ))}
                  </RadioGroup>

                  <Box sx={{ mt: 2.5, display: 'flex', gap: 1.5 }}>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => setSortBy('song_number')}
                      sx={{
                        bgcolor: '#CBD5E1',
                        color: '#1E293B',
                        fontWeight: 700,
                        textTransform: 'none',
                        borderRadius: '8px',
                        '&:hover': { bgcolor: '#94A3B8' },
                      }}
                    >
                      Clear all
                    </Button>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => setSortBottomSheetOpen(false)}
                      sx={{
                        bgcolor: '#1F6F78',
                        color: '#FFFFFF',
                        fontWeight: 700,
                        textTransform: 'none',
                        borderRadius: '8px',
                        '&:hover': { bgcolor: '#155E63' },
                      }}
                    >
                      Apply
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        )}

        {/* ======================================================== */}
        {/* SCREEN 2: SONG DETAILS VIEW (Matches User Screenshot 3)   */}
        {/* ======================================================== */}
        {screenMode === 'details' && (
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              bgcolor: '#FFFFFF',
              color: '#0F172A',
              display: 'flex',
              flexDirection: 'column',
              p: 2.5,
              pb: 12,
            }}
          >
            {/* Action Buttons Toolbar at Top (Search, Play, Font, T↓, T↑) */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1.5,
                mb: 2.5,
              }}
            >
              {/* Search Icon */}
              <IconButton size="small" sx={{ color: '#0D9488' }}>
                <SearchIcon sx={{ fontSize: 24 }} />
              </IconButton>

              {/* Play / Pause Circular Button */}
              <IconButton
                size="small"
                onClick={() => setIsPlaying(!isPlaying)}
                sx={{
                  bgcolor: '#0D9488',
                  color: '#FFFFFF',
                  width: 36,
                  height: 36,
                  '&:hover': { bgcolor: '#0F766E' },
                }}
              >
                {isPlaying ? <PauseCircleFilledIcon sx={{ fontSize: 24 }} /> : <PlayCircleFilledIcon sx={{ fontSize: 24 }} />}
              </IconButton>

              {/* Font Format Icon */}
              <IconButton
                size="small"
                sx={{
                  bgcolor: '#0D9488',
                  color: '#FFFFFF',
                  width: 36,
                  height: 36,
                  fontWeight: 800,
                  fontSize: '1rem',
                  fontFamily: 'serif',
                  '&:hover': { bgcolor: '#0F766E' },
                }}
              >
                f
              </IconButton>

              {/* Text Decrease */}
              <IconButton
                size="small"
                onClick={() => setFontSizeOffset(prev => Math.max(prev - 2, -4))}
                sx={{
                  bgcolor: '#0D9488',
                  color: '#FFFFFF',
                  width: 36,
                  height: 36,
                  '&:hover': { bgcolor: '#0F766E' },
                }}
              >
                <TextDecreaseIcon sx={{ fontSize: 20 }} />
              </IconButton>

              {/* Text Increase */}
              <IconButton
                size="small"
                onClick={() => setFontSizeOffset(prev => Math.min(prev + 2, 8))}
                sx={{
                  bgcolor: '#0D9488',
                  color: '#FFFFFF',
                  width: 36,
                  height: 36,
                  '&:hover': { bgcolor: '#0F766E' },
                }}
              >
                <TextIncreaseIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Box>

            {/* Song Title & Number */}
            <Box sx={{ mb: 2 }}>
              <Typography
                sx={{
                  fontSize: `${1.1 + fontSizeOffset * 0.05}rem`,
                  fontWeight: 800,
                  color: '#164E63',
                  lineHeight: 1.35,
                  mb: 0.5,
                }}
              >
                {activeSong.title}
              </Typography>
              <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: '#334155' }}>
                Song #{activeSong.number}
              </Typography>
            </Box>

            {/* Song Lyrics (Formatted Stanzas) */}
            <Box sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
              <Typography
                sx={{
                  fontSize: `${0.95 + fontSizeOffset * 0.05}rem`,
                  color: '#0F172A',
                  fontWeight: 500,
                  lineHeight: 1.8,
                  fontFamily: activeSong.language === 'Telugu' ? '"Noto Sans Telugu", sans-serif' : 'inherit',
                }}
              >
                {activeSong.lyrics}
              </Typography>
            </Box>
          </Box>
        )}

        {/* Sticky Audio Controls Footer (Present in Song Details) */}
        {screenMode === 'details' && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              bgcolor: '#F8FAFC',
              borderTop: '1px solid #E2E8F0',
              px: 2,
              py: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2.5,
              zIndex: 75,
            }}
          >
            <IconButton size="small" sx={{ color: '#0F766E' }}>
              <SkipPreviousIcon sx={{ fontSize: 26 }} />
            </IconButton>
            <IconButton size="small" sx={{ color: '#0F766E' }}>
              <FastRewindIcon sx={{ fontSize: 26 }} />
            </IconButton>
            <IconButton
              onClick={() => setIsPlaying(!isPlaying)}
              sx={{
                bgcolor: '#0F766E',
                color: '#FFFFFF',
                width: 44,
                height: 44,
                '&:hover': { bgcolor: '#0D9488' },
              }}
            >
              {isPlaying ? <PauseCircleFilledIcon sx={{ fontSize: 30 }} /> : <PlayCircleFilledIcon sx={{ fontSize: 30 }} />}
            </IconButton>
            <IconButton size="small" sx={{ color: '#0F766E' }}>
              <FastForwardIcon sx={{ fontSize: 26 }} />
            </IconButton>
            <IconButton size="small" sx={{ color: '#0F766E' }}>
              <SkipNextIcon sx={{ fontSize: 26 }} />
            </IconButton>
          </Box>
        )}

        {/* Bottom Tab Navigation Bar (Present in Songs List) */}
        {screenMode === 'list' && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              bgcolor: '#000000',
              borderTop: '1px solid rgba(255,255,255,0.1)',
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              py: 0.8,
              zIndex: 80,
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#94A3B8' }}>
              <HomeIcon sx={{ fontSize: 22 }} />
              <Typography sx={{ fontSize: '0.62rem', fontWeight: 600 }}>Home</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#94A3B8' }}>
              <PanToolAltIcon sx={{ fontSize: 22 }} />
              <Typography sx={{ fontSize: '0.62rem', fontWeight: 600 }}>Prayers</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#FFFFFF' }}>
              <QueueMusicIcon sx={{ fontSize: 22, color: '#38BDF8' }} />
              <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, color: '#38BDF8' }}>Songs</Typography>
              <Box sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: '#38BDF8', mt: 0.3 }} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#94A3B8' }}>
              <EventAvailableIcon sx={{ fontSize: 22 }} />
              <Typography sx={{ fontSize: '0.62rem', fontWeight: 600 }}>Events</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#94A3B8' }}>
              <AccountCircleIcon sx={{ fontSize: 22 }} />
              <Typography sx={{ fontSize: '0.62rem', fontWeight: 600 }}>Profile</Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Dialog>
  );
}
